import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/FirldTrips/2023/Class8/1.jpg';
// import p2 from 'assests/Photos/FirldTrips/2023/Class8/2.jpg';
// import p3 from 'assests/Photos/FirldTrips/2023/Class8/3.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar_2023 from '../Sidebar_2023';


const CurricularClass82023 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_archive_url: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class8/1.webp`;
  const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class8/2.webp`;
  const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class8/3.webp`;


  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
        src: p2,
        source:p2,
        rows: 1,
        cols: 1,
    },
    {
        src: p3,
        source: p3,
        rows: 1,
        cols: 1,
    },
      
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      ‘Field Trip to Wild Valley Resort’
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
 Class: 8   Date: 4 SEPTEMBER 2023 (Monday)

        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        National Public School Yeshwantpur had organized a short excursion for the students of Class 8 on Monday, 4 September 2023 to Wild Valley Resort, situated on Kanakapura Road. 
        The day was filled with adventure and learning, providing them with valuable experiences and memories.
        <br />
        The day began as the students eagerly boarded the bus at 7:50 AM. They reached their destination by 9:00 AM, where they were served sumptuous breakfast. Once energized, the students were organised into groups to partake in a variety of activities that brought them closer to nature and tested their physical and mental abilities.
        <br />
        The activities included invigorating nature walks, thrilling zip-line, challenging rope walks, ladder climbing, lively rain dances, and engaging team-building games. These activities not only provided a dose of excitement but also allowed the students to assess their own strengths and weaknesses, both physical and psychological.
        <br />
        Amidst all the adventures, the students relished the delectable food and snacks served at the resort. It was a day free from books and pens, yet it became a chapter in their lives filled with self-discovery and cherished memories.
        <br/>
        This field trip served as a reminder that learning extends far beyond the classroom. It was an opportunity for students to connect with nature, discover hidden talents and create beautiful moments that they will carry with them in the book of their lives.
        </Typography>
      </Box>
     

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
                <Sidebar_2023/>
             </Box>

         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default CurricularClass82023;